import { render, staticRenderFns } from "./ReferralDetailHeader.vue?vue&type=template&id=21062da2&"
import script from "./ReferralDetailHeader.vue?vue&type=script&lang=ts&"
export * from "./ReferralDetailHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralDetailHeader.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports